'use strict';

/**
 * Do not edit directly, this file was auto-generated.
 */

var mobile = {
  "theme": "mobile",
  "radius": {
    "surfaceSmall": 4,
    "surfaceMedium": 8,
    "surfaceLarge": 16,
    "surfaceXlarge": 32,
    "backgroundXsmall": 3,
    "backgroundSmall": 4,
    "backgroundMedium": 8,
    "backgroundLarge": 16,
    "backgroundXlarge": 32,
    "backgroundRounded": 300
  },
  "borderWeight": {
    "xsmall": 1,
    "small": 1,
    "medium": 2
  },
  "size": {
    "heightXsmall": 24,
    "heightSmall": 34,
    "heightMedium": 44,
    "heightLarge": 52,
    "heightXlarge": 56,
    "heightXxxsmall": 18,
    "heightXxsmall": 20,
    "widthSmall": 34,
    "widthMedium": 44,
    "widthLarge": 52,
    "widthXxxsmall": 18,
    "widthXxsmall": 20,
    "widthXsmall": 24
  },
  "space": {
    "gapSmall": 4,
    "gapMedium": 8,
    "gapInternal": 16,
    "gapSection": 24,
    "gapPage": 32,
    "gapFooter": 64,
    "gapXsmall": 4,
    "paddingDynamicXxsmall": 4,
    "paddingDynamicXsmall": 8,
    "paddingDynamicSmall": 16,
    "paddingDynamicMedium": 16,
    "paddingDynamicLarge": 24,
    "paddingDynamicXlarge": 24,
    "paddingStaticXxsmall": 4,
    "paddingStaticXsmall": 8,
    "paddingStaticSmall": 16,
    "paddingStaticMedium": 24,
    "paddingStaticLarge": 32,
    "paddingStaticXlarge": 40,
    "paddingStaticXxlarge": 48
  },
  "button": {
    "radius": 8,
    "stroke": 1,
    "sizeSmall": 34,
    "sizeMedium": 44,
    "sizeLarge": 52
  },
  "status": {
    "borderRadius": 4,
    "heightSmall": 24,
    "heightMedium": 34,
    "gapSmall": 4,
    "gapMedium": 8,
    "padding": 8
  },
  "actionTile": {
    "paddingTop": 16,
    "borderRadius": 8,
    "paddingRight": 8,
    "paddingLeft": 8,
    "paddingBottom": 16
  },
  "accordion": {
    "borderRadius": 8
  },
  "modal": {
    "paddingTop": 32,
    "paddingRight": 24,
    "paddingLeft": 24,
    "paddingBottom": 32
  },
  "effect": {
    "stateFocusedStroke": 2,
    "elevationOverlayX": 0,
    "elevationOverlayY": 4,
    "elevationOverlayBlur": 16,
    "elevationOverlaySpread": 0,
    "elevationOverlayOpacity": 16,
    "elevationOverflowX": 0,
    "elevationOverflowY": -2,
    "elevationOverflowBlur": 8,
    "elevationOverflowSpread": 0,
    "elevationOverflowOpacity": 16,
    "elevationRaisedX": 0,
    "elevationRaisedY": 2,
    "elevationRaisedBlur": 6,
    "elevationRaisedSpread": 0,
    "elevationRaisedOpacity": 16
  },
  "type": {
    "familyDecorative": "Besley",
    "familyBase": "Mulish"
  },
  "textSize": {
    "h1": 28,
    "h2": 24,
    "h3": 20,
    "h4": 19,
    "h5": 17,
    "body": 16,
    "callout": 15,
    "footnote": 13,
    "caption": 12,
    "subcaption": 11,
    "smallest": 9
  },
  "weight": {
    "regular": "400",
    "medium": "500",
    "semibold": "600",
    "bold": "700"
  },
  "letterSpacing": {
    "caption": 0,
    "h1": 0,
    "h2": 0,
    "h3": 0,
    "h4": 0,
    "h5": 0,
    "body": 0,
    "callout": 0,
    "footnote": 0,
    "subcaption": 0,
    "smallest": 0
  },
  "lineHeight": {
    "h1": 40,
    "h2": 32,
    "h3": 32,
    "h4": 24,
    "h5": 24,
    "body": 24,
    "footnote": 20,
    "callout": 20,
    "caption": 16,
    "subcaption": 16,
    "smallest": 18
  }
};

exports.mobile = mobile;
//# sourceMappingURL=mobile.cjs.map
